import { ResourceType } from '../../shared/resource-type';

/**
 * The resource type for TranslationRequest
 */
export const TRANSLATION_REQUEST = new ResourceType('translationrequest');
